<div class="d-flex flex-row justify-content-between w-100 align-items-center pe-4" id="header-container">
  <h1 mat-dialog-title class="heading text-primary">Attachments</h1>
  <div class="d-flex align-items-center justify-content-end gap-2 fs-18">
    <mat-icon class="cursor-pointer text-dark" matTooltip="Copy Link" (click)="onCopyLink()" [cdkCopyToClipboard]="selectedDocument.fileUrl"> link </mat-icon>
    <mat-icon class="cursor-pointer text-dark" (click)="onDownload()" matTooltip="Download"> download </mat-icon>

    @if (documentViewerModal.FileList.length > 1) {
      <mat-icon class="cursor-pointer text-dark" (click)="onNext(-1)" matTooltip="Previous"> arrow_back </mat-icon>
      <mat-icon class="cursor-pointer text-dark" (click)="onNext(1)" matTooltip="Next"> arrow_forward </mat-icon>
    }
  </div>
</div>
<mat-dialog-content>
  <div class="row m-2 p-4 attachments-preview-container">
    <div class="col-12 mt-2 d-flex justify-content-center align-items-center">
      <!-- @if (documentViewerModal.FileList.length > 1) {
        <div class="icon-container ps-2 cursor-pointer" (click)="onNext(-1)" matRipple>
          <mat-icon> arrow_back_ios </mat-icon>
        </div>
      } -->
      <div class="document-content mx-2">
        @if (selectedDocument) {
          <div
            class="preview-icon cursor-pointer"
            id="image-container"
            [ngClass]="selectedDocument.fileType === FILE_TYPE.IMAGE ? 'image-wrapper' : 'd-flex justify-content-center align-items-center'">
            @switch (selectedDocument.fileType) {
              @case (FILE_TYPE.IMAGE) {
                <img [src]="selectedDocument.fileUrl" />
              }
              @case (FILE_TYPE.PDF) {
                <pdf-viewer
                  [src]="selectedDocument.fileUrl"
                  [rotation]="0"
                  [original-size]="false"
                  [show-all]="true"
                  [fit-to-page]="false"
                  [zoom]="0.5"
                  [zoom-scale]="'page-width'"
                  [stick-to-page]="false"
                  [render-text]="true"
                  [external-link-target]="'blank'"
                  [autoresize]="true"
                  [show-borders]="false"
                  class="icon pdf"></pdf-viewer>
              }
              @case (FILE_TYPE.ZIP) {
                <img src="global-assets/mobi-office-ui/file-icons/zip.png" class="icon" [alt]="selectedDocument.fileName" />
              }
              @case (FILE_TYPE.RAR) {
                <img src="global-assets/mobi-office-ui/file-icons/rar.png" class="icon" [alt]="selectedDocument.fileName" />
              }
              @case (FILE_TYPE.GZ) {
                <img src="global-assets/mobi-office-ui/file-icons/gz.png" class="icon" [alt]="selectedDocument.fileName" />
              }
              @case (FILE_TYPE.PPT) {
                <img src="global-assets/mobi-office-ui/file-icons/ppt.png" class="icon" [alt]="selectedDocument.fileName" />
              }
              @case (FILE_TYPE.EXCEL) {
                <img src="global-assets/mobi-office-ui/file-icons/csv.png" class="icon" [alt]="selectedDocument.fileName" />
              }
              @case (FILE_TYPE.VIDEO) {
                <video class="icon" autoplay controls>
                  <source [src]="selectedDocument.fileUrl" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              }
              @case (FILE_TYPE.AUDIO) {
                <img src="global-assets/mobi-office-ui/file-icons/mp3.png" class="icon" [alt]="selectedDocument.fileName" />
              }
              @case (FILE_TYPE.DOC) {
                <img src="global-assets/mobi-office-ui/file-icons/doc.png" class="icon" [alt]="selectedDocument.fileName" />
              }
              @case (FILE_TYPE.TEXT) {
                <img src="global-assets/mobi-office-ui/file-icons/txt.png" class="icon" [alt]="selectedDocument.fileName" />
              }
              @case (FILE_TYPE.XML) {
                <img src="global-assets/mobi-office-ui/file-icons/xml.png" class="icon" [alt]="selectedDocument.fileName" />
              }
              @case (FILE_TYPE.JSON) {
                <img src="global-assets/mobi-office-ui/file-icons/json-file.png" class="icon" [alt]="selectedDocument.fileName" />
              }
              @case (FILE_TYPE.SQL) {
                <img src="global-assets/mobi-office-ui/file-icons/sql.png" class="icon" [alt]="selectedDocument.fileName" />
              }
              @default {
                <img src="global-assets/mobi-office-ui/file-icons/doc.png" class="icon" [alt]="selectedDocument.fileName" />
              }
            }
          </div>
        }
      </div>
      <!-- @if (documentViewerModal.FileList.length > 1) {
        <div class="icon-container cursor-pointer" (click)="onNext(1)" matRipple>
          <mat-icon> arrow_forward_ios </mat-icon>
        </div>
      } -->
    </div>
    <!-- <div class="col-12 mt-2">
      <div class="file-preview-section">
        @for (item of documentViewerModal.FileList; track $index) {
          <div class="preview-icon cursor-pointer" [ngClass]="{ 'border-one border-primary': $index === selectedDocumentIndex }" matTooltip="Click to view" (click)="selectedDocumentIndex = $index">
            @if (item.fileType === FILE_TYPE.IMAGE) {
              <img [src]="item.fileUrl" class="icon" [alt]="item.fileName" />
            }
            @if (item.fileType === FILE_TYPE.PDF) {
              <img src="global-assets/mobi-office-ui/file-icons/pdf.png" class="icon" [alt]="item.fileName" />
            }
            @if (item.fileType === FILE_TYPE.EXCEL) {
              <img src="global-assets/mobi-office-ui/file-icons/csv.png" class="icon" [alt]="item.fileName" />
            }
            @if (item.fileType === FILE_TYPE.VIDEO) {
              <img src="global-assets/mobi-office-ui/file-icons/mp4.png" class="icon" [alt]="item.fileName" />
            }
            @if (item.fileType === FILE_TYPE.AUDIO) {
              <img src="global-assets/mobi-office-ui/file-icons/mp3.png" class="icon" [alt]="item.fileName" />
            }
            @if (item.fileType === FILE_TYPE.DOC) {
              <img src="global-assets/mobi-office-ui/file-icons/doc.png" class="icon" [alt]="item.fileName" />
            }
            @if (item.fileType === FILE_TYPE.TEXT) {
              <img src="global-assets/mobi-office-ui/file-icons/txt.png" class="icon" [alt]="item.fileName" />
            }
          </div>
        }
      </div>
    </div> -->
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end"><button class="btn-md-outlined-error" matRipple [mat-dialog-close]="false">Close</button></mat-dialog-actions>
